import Dexie from 'dexie'
import ApiService from '@/common/api.service'

const local = {

    install(Vue, opt) {
        const defaults = {
            dbName: 'pos-local'
        }

        const options = {
            ...defaults,
            ...opt
        }

        var db = new Dexie(options.dbName)

        db.version(1).stores({
            products: "&product_id, category_id",
            order: "++id, user",
            user: "role",
            users: "nfc",
            orders: "++id, user.id, synced, status",
            preorders: "&id, customer_id",
            errors: "++id, date",
            settings: "key"
        })

        db.open().catch(function (e) {
            console.error("Open failed: " + e.stack);
        })

        let local = {
            setProducts: (products) => {
                db.products.clear()
                products.forEach(product => {
                    db.products.add(product)
                })
            },
            getMenu: () => {
                let menu = {}
                let unique_categories_ids = []
                return new Dexie.Promise(function (resolve, reject) {
                    db.products.each(product => {
                        if (unique_categories_ids.indexOf(product.category_id) == -1) {
                            unique_categories_ids.push(product.category_id)
                            menu[product.category_id] = {
                                category: product.category,
                                products: {}
                            }
                        }
                        menu[product.category_id].products[product.product_id] = product.product.data
                    }).then(() => {
                        resolve(menu)
                    }).catch (err => {
                        console.error (err)
                        reject(err)
                    });
                })
            },
            getProducts: () => {
                return new Dexie.Promise(function (resolve, reject) {
                    db.products.toArray(products => {
                        resolve(products)
                    }).catch (err => {
                        console.error (err)
                        reject(err)
                    });
                })
            },
            setOrder: (order) => {
                db.order.clear()
                db.order.add(order)
            },
            getOrder: (user_id) => {
                return db.order.toCollection().first()
            },
            deleteOrder: () => {
                db.order.clear()
            },
            updateOrderItems: (items) => {
                db.order.toCollection().first(order => {
                    db.order.update(order.id, {items: items})
                })
            },
            updateSyncedOrder: (id, syncedOrder) => {
                db.orders.get(id).then ( (order) => {
                    order.synced = 1
                    order.syncer_id = syncedOrder.id
                    order.status = syncedOrder.status
                    order.total = syncedOrder.total
                    db.orders.delete(id).then( () => {
                        db.orders.add(order)
                    })
                })
            },
            syncOrder: (id) => {
                return new Dexie.Promise(function (resolve, reject) {
                    db.orders.get(id).then ( (order) => {
                        ApiService.post('pos/order', order).then(result => {
                            delete order['id']
                            order.synced = 1
                            order.synced_id = result.data.data.id
                            order.status = result.data.data.status
                            order.total = result.data.data.total
                            db.orders.delete(id).then( () => {
                                db.orders.add(order)
                                resolve(order)
                            })
                        }).catch(error => {
                            reject(error)
                        })
                    })
                })
            },
            syncAllOrders: () => {
                return new Dexie.Promise(function (resolve, reject) {
                    db.orders.where('synced').equals(0).toArray().then((unsyncedOrders) => {
                        unsyncedOrders.forEach( order => {
                            ApiService.post('pos/order', order).then( result => {
                                const id = order.id
                                order.synced = 1
                                order.synced_id = result.data.data.id
                                order.status = result.data.data.status
                                order.total = result.data.data.total
                                db.orders.delete(id).then( () => {
                                    db.orders.add(order)
                                    resolve(order)
                                })
                            })  
                        })
                    })
                })
            },
            updatePayments: (payments) => {
                db.order.toCollection().first(order => {
                    db.order.update(order.id, {payments: payments})
                })
            },
            hasOrder: () => {
                return db.order.count()
            },
            addUser: (user) => {
                //console.log(user)
            },
            setUser: (user) => {
                db.user.clear()
                db.user.add(user)
            },
            getUser: () => {
                return new Dexie.Promise(function (resolve, reject) {
                    db.user.toArray().then( user => {
                        resolve(user[0])
                    })
                })
            },
            setUsers: () => {
                return new Dexie.Promise(function (resolve, reject) {
                    ApiService.get(`pos/users`).then((users) => {
                        if (users) {
                            db.users.clear()
                            users.data.data.forEach( user => {
                                db.users.add(user)
                            })

                            resolve(users)
                        }
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            setPreorders: () => {
                return new Dexie.Promise(function (resolve, reject) {
                    ApiService.get(`pos/preorder/list`).then((preorders) => {
                        if (preorders) {
                            db.preorders.clear()
                            preorders.data.data.forEach( preorder => {
                                db.preorders.add(preorder)
                            })
                            resolve(preorders)
                        }  
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getPreorder: (nfc) => {
                return new Dexie.Promise(function (resolve, reject) {
                    db.users.where('nfc').equals(nfc).first().then(user => {
                        if(! user) {
                            reject("NFC not found")
                            return
                        }
                        db.preorders.where('customer_id').equals(user.id).first().then( order => {
                            resolve(order)
                        }).catch(err => {
                            reject(err)
                        })
                    }).catch(err => {
                        reject(err)
                    })
                })              
            },
            addOrder: (order) => {
                return new Dexie.Promise(function (resolve, reject) {
                    db.orders.add(order).then(id => {
                        resolve(id)
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            removeOrder: (id) => {
                return new Dexie.Promise(function (resolve, reject) {
                    db.orders.delete(id).then(() => {
                        resolve(id)
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getUnsyncedOrders: () => {
                return db.orders.where('synced').equals(0).toArray()
            },
            addError: (error) => {
                db.errors.add(error)
            },
            getErrors: () => {
                return db.errors.toArray()
            },
            // settings
            set: (setting) => {
                db.settings.put(setting)
            },
            get: (key) => {
                return db.settings.get(key).toArray()
            }
        }

        Vue.prototype.$db = local

    }
};

export default local;
